import { ConfirmationDialog } from "../../../assets/types";
import { FormatHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import { VfxDialogProps } from "../../../assets/vfx/dialog/vfxDialogProps";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { SectionDto } from "../../../services/dto";
import DisplayData from "../../common/DisplayData/DisplayData";

interface QuestionnaireSectionViewProps {
  data: SectionDto | undefined;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const SectionView = (props: QuestionnaireSectionViewProps) => {
  const modalDialogProps: VfxDialogProps | undefined =
    new ConfirmationDialog().get(props.onDelete, "Delete", {
      Name: props.data?.name ?? Constants.emptyString,
    });

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      onEdit={props.onEdit}
      title="View Section"
      modalDialogProps={modalDialogProps}
      onDelete={props.onDelete}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data?.name} />
          <DisplayData
            text="Description"
            importedData={props.data?.description}
          />
          <DisplayData text="Order" importedData={props.data?.order} />
          <DisplayData
            text="Start Date"
            importedData={
              props.data?.startDate
                ? FormatHelper.formatDate(props.data.startDate)
                : Constants.emptyString
            }
          />
          {props.data?.endDate && (
            <DisplayData
              text="End Date"
              importedData={FormatHelper.formatDate(props.data.endDate)}
            />
          )}
        </>
      )}
    </Drawer.View>
  );
};
